import { FieldPath, FieldValues } from 'react-hook-form'
import { ICustomFieldComponentProps } from 'types'
import { ControlledInput } from 'components/ControlledFields/ControlledFormElements/ControlledInput/ControlledInput'

type FieldConfig = {
  name: string
  label: string
  placeholder: string
}

type FullNameFieldsProps = ICustomFieldComponentProps<
  FieldValues,
  FieldPath<FieldValues>,
  {
    fields?: FieldConfig[]
  }
>

export const FullNameFields = ({ fields = [] }: FullNameFieldsProps) => (
  <div className="flex flex-col gap-1">
    {fields.map(field => (
      <ControlledInput
        key={field.name}
        name={field.name}
        label={field.label}
        placeholder={field.placeholder}
      />
    ))}
  </div>
)
